import { Component, Input, DoCheck } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { LinkGroup } from '../../link-group/link-group';

const NUMBER_REGEX = /^[0-9]*$/;


@Component({
  selector: 't-link-group-form',
  templateUrl: './link-group-form.component.html',
})
export class LinkGroupFormComponent implements DoCheck {

  @Input()
  group: LinkGroup

  name: FormControl

  ngDoCheck() {
    this.buildForm();
  }

  buildForm() {
    this.name = new FormControl(this.group.name, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.group.name = value;
    });
  }
}